module.exports = __webpack_public_path__ + "img/20180803-methow-valley-00002.7870d9bb.jpg";